import { MyApp } from "./app.component";
import { NgModule } from "@angular/core";
import { IonicApp, IonicModule  } from "ionic-angular";
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
// import { HTTP } from '@ionic-native/http';
// import { Http } from '@angular/http';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from "../pages/home/home";
import { RegionsPage } from "../pages/regions/regions";
import { VariablesPage } from "../pages/variables/variables";
import { DepthPage } from "../pages/depths/depths";
import { PalettePage } from "../pages/palette/palette";
import { ModalPage } from "../pages/modal/modal";

import { ConnectorProvider } from '../providers/connector/connector';
// import { DeviceOrientation, DeviceOrientationCompassHeading } from '@ionic-native/device-orientation';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { StaticConstantsProvider } from '../providers/static-constants/static-constants';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { Title }  from '@angular/platform-browser';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    RegionsPage,
    VariablesPage,
    DepthPage,
    PalettePage,
    ModalPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      scrollPadding: false,
      scrollAssist: true,
      autoFocusAssist: false,
      monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      monthShortNames: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec' ],
      dayNames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      dayShortNames: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
    }),
    TranslateModule.forRoot({
      loader: {
           provide: TranslateLoader,
           useFactory: (createTranslateLoader),
           deps: [HttpClient]
         }
      })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    RegionsPage,
    VariablesPage,
    DepthPage,
    PalettePage,
    ModalPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ConnectorProvider,
    StaticConstantsProvider,
    // DeviceOrientation
    ScreenOrientation,
    InAppBrowser,
    Title
  ]
})



export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts